import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, ArrowRight } from 'lucide-react';

const DonationBanner = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-[#0a0a0a] to-[#1a0a0a]">
      <div className="max-w-[1920px] mx-auto px-6 md:px-12">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-[#1a1a1a] to-[#2a1a1a] border border-white/10">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 bg-[#e4002b] rounded-full blur-[120px]" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#e4002b] rounded-full blur-[100px]" />
          </div>

          <div className="relative grid md:grid-cols-2 gap-8 p-8 md:p-12 lg:p-16">
            <div className="flex flex-col justify-center">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-[#e4002b]/20 flex items-center justify-center">
                  <Heart className="w-6 h-6 text-[#e4002b]" />
                </div>
                <span className="text-[#e4002b] text-sm font-medium tracking-wider uppercase">
                  Colabora con nosotros
                </span>
              </div>
              
              <h2 className="text-white text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight">
                Tu pantalla transforma tu comunidad
              </h2>
              
              <p className="text-white/70 text-base md:text-lg mb-8 max-w-lg">
                Cada butaca cuenta. Ayúdanos a <span className="text-[#e4002b] font-semibold">democratizar el acceso a la alta cultura</span> y 
                llevar los grandes escenarios del mundo a cada rincón.
              </p>
              
              <div className="flex flex-wrap gap-3">
                <Link 
                  to="/colabora"
                  className="inline-flex items-center gap-2 px-8 py-4 bg-[#e4002b] text-white font-medium rounded-lg hover:bg-[#c70024] transition-colors"
                  data-testid="donation-banner-cta"
                >
                  Descubre cómo unirte
                  <ArrowRight className="w-4 h-4" />
                </Link>
                <Link 
                  to="/colabora#red-bravo"
                  className="inline-flex items-center gap-2 px-8 py-4 border border-white/20 text-white font-medium rounded-lg hover:bg-white/10 transition-colors"
                  data-testid="donation-banner-cinemas"
                >
                  Ver cines con Bravo
                </Link>
              </div>
            </div>

            <div className="relative h-64 md:h-auto">
              <div className="absolute inset-0 grid grid-cols-2 gap-4">
                <div className="relative overflow-hidden rounded-lg">
                  <img
                    src="https://images.unsplash.com/photo-1518834107812-67b0b7c58434?w=600&q=80"
                    alt="Giselle - Ballet"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="relative overflow-hidden rounded-lg mt-8">
                  <img
                    src="https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=600&q=80"
                    alt="La Traviata - Concierto"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DonationBanner;
